export function compare(a, b){
  return String(a) === String(b)
}
